import { createTheme } from '@mui/material/styles';

const HEX_COLOR_REGEX = /^#([A-Fa-f0-9]{3}|[A-Fa-f0-9]{6})$/;

const parseHexColor = (value, fallback) => {
  if (!value) return fallback;
  const trimmed = value.trim();
  return HEX_COLOR_REGEX.test(trimmed) ? trimmed : fallback;
};

const parseMode = (value) => {
  if (!value) return 'light';
  return value.toLowerCase() === 'dark' ? 'dark' : 'light';
};

const fromPublic = (path) => `${process.env.PUBLIC_URL}${path}`;

export const BRANDING = {
  appName: process.env.REACT_APP_APP_NAME || 'Jazmin Moda y Accesorios',
  mode: parseMode(process.env.REACT_APP_THEME_MODE),
  primaryColor: parseHexColor(process.env.REACT_APP_PRIMARY_COLOR, '#1976d2'),
  secondaryColor: parseHexColor(process.env.REACT_APP_SECONDARY_COLOR, '#9c27b0'),
  backgroundColor: parseHexColor(process.env.REACT_APP_BACKGROUND_COLOR, '#f6ede1'),
  paperColor: parseHexColor(process.env.REACT_APP_PAPER_COLOR, '#ffffff'),
  themeColorMeta: parseHexColor(process.env.REACT_APP_THEME_COLOR, '#1976d2'),
  logoUrl: process.env.REACT_APP_BRAND_LOGO_URL || fromPublic('/jazminmya.png'),
  faviconUrl: process.env.REACT_APP_BRAND_FAVICON_URL || fromPublic('/jazicon.ico'),
  appleTouchIconUrl:
    process.env.REACT_APP_APPLE_TOUCH_ICON_URL || fromPublic('/jazminmya.png'),
  movementColors: {
    inversionBg: parseHexColor(process.env.REACT_APP_MOVEMENT_INVEST_BG, '#FFEB9C'),
    inversionText: parseHexColor(process.env.REACT_APP_MOVEMENT_INVEST_TEXT, '#9C5700'),
    reinversionBg: parseHexColor(process.env.REACT_APP_MOVEMENT_REINVEST_BG, '#FFCC99'),
    reinversionText: parseHexColor(process.env.REACT_APP_MOVEMENT_REINVEST_TEXT, '#3F3F76'),
    expenseBg: parseHexColor(process.env.REACT_APP_MOVEMENT_EXPENSE_BG, '#FFC7CE'),
    expenseText: parseHexColor(process.env.REACT_APP_MOVEMENT_EXPENSE_TEXT, '#9C0006'),
    saleBg: parseHexColor(process.env.REACT_APP_MOVEMENT_SALE_BG, '#70AD47'),
    saleText: parseHexColor(process.env.REACT_APP_MOVEMENT_SALE_TEXT, '#FFFFFF'),
    availableBg: parseHexColor(process.env.REACT_APP_MOVEMENT_AVAILABLE_BG, '#5B9BD5'),
    availableText: parseHexColor(process.env.REACT_APP_MOVEMENT_AVAILABLE_TEXT, '#FFFFFF'),
  }
};

export const createAppTheme = () =>
  createTheme({
    palette: {
      mode: BRANDING.mode,
      primary: { main: BRANDING.primaryColor },
      secondary: { main: BRANDING.secondaryColor },
      background: {
        default: BRANDING.backgroundColor,
        paper: BRANDING.paperColor,
      },
    },
  });

const ensureLinkTag = (rel) => {
  let tag = document.querySelector(`link[rel='${rel}']`);
  if (!tag) {
    tag = document.createElement('link');
    tag.setAttribute('rel', rel);
    document.head.appendChild(tag);
  }
  return tag;
};

export const applyBrandingToDocument = () => {
  if (typeof document === 'undefined') return;

  document.title = BRANDING.appName;

  const themeColorMeta =
    document.querySelector("meta[name='theme-color']") ||
    (() => {
      const meta = document.createElement('meta');
      meta.setAttribute('name', 'theme-color');
      document.head.appendChild(meta);
      return meta;
    })();

  themeColorMeta.setAttribute('content', BRANDING.themeColorMeta);

  const favicon = ensureLinkTag('icon');
  favicon.setAttribute('href', BRANDING.faviconUrl);

  const appleIcon = ensureLinkTag('apple-touch-icon');
  appleIcon.setAttribute('href', BRANDING.appleTouchIconUrl);
};
